import { apiClient } from '../apiClient';

/** Row from GET /companies/{company_id}/icp-definition-items (pt-icp-definition artifact_items). */
export interface IcpDefinitionItemRow {
  artifact_item_id: string;
  company_artifact_id: string;
  artifact_name: string;
  status?: string;
  data: Record<string, unknown>;
}

export interface IcpDefinitionItemsResponse {
  company_id: string;
  items: IcpDefinitionItemRow[];
  count: number;
}

/**
 * Lists ICP definition artifact items for the tenant (runtime DB truth).
 * Used after IntentML import to confirm pt-icp-definition rows exist.
 */
export async function fetchIcpDefinitionItems(companyId: string): Promise<IcpDefinitionItemsResponse> {
  const { data } = await apiClient.get<IcpDefinitionItemsResponse>(
    `/companies/${encodeURIComponent(companyId)}/icp-definition-items`
  );
  return {
    company_id: data.company_id,
    items: data.items ?? [],
    count: typeof data.count === 'number' ? data.count : (data.items?.length ?? 0),
  };
}
